"use client";

// import Button from "@/components/atom/Button";
import { useState } from "react";

import { ChevronsDownUp, CalendarDays } from "lucide-react";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { addDays, format } from "date-fns";
import { Header } from "../../../_component";

export default function HeaderDompetDigital(props) {
  return (
    <div className='flex flex-col xs:flex-row justify-between xs:items-end gap-8'>
      <Header label={"Dompet Digital"} />
      <DatePickerWithPresets {...props} />
    </div>
  );
}

export function DatePickerWithPresets(props) {
  const [date, setDate] = useState(null);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "min-w-[240px] justify-start text-left font-normal",
            !date && "text-muted-foreground"
          )}>
          <CalendarDays className='mr-2 h-4 w-4' />
          {date ? (
            !date?.date_until ? (
              format(date?.date_from ?? new Date(), "PPP")
            ) : (
              `${format(date?.date_from, "PPP")} - ${format(
                date?.date_until,
                "PPP"
              )}`
            )
          ) : (
            <span>Pick a date</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align='start'
        className='flex w-auto flex-col space-y-2 p-2'>
        <Select
          onValueChange={(value) => {
            console.log(Math.abs(parseInt(value)));
            setDate({ date_numeric: addDays(new Date(), parseInt(value)) });
            props?.getReportDashboard({
              date_from: "",
              date_until: "",
              date_numeric: Math.abs(parseInt(value)),
            });
          }}>
          <SelectTrigger>
            <SelectValue placeholder='Select' />
          </SelectTrigger>
          <SelectContent position='popper'>
            <SelectItem value='0'>Today</SelectItem>
            <SelectItem value='-7'>In a week ago</SelectItem>
            <SelectItem value='-14'>In 2 week ago</SelectItem>
            <SelectItem value='-21'>In 3 week ago</SelectItem>
          </SelectContent>
        </Select>
        <div className='rounded-md border'>
          <Calendar
            mode='range'
            min={2}
            max={14}
            disabled={{ after: new Date() }}
            selected={
              date?.date_numeric ?? {
                from: date?.date_from,
                to: date?.date_until,
              }
            }
            onSelect={(a) => {
              console.log(a);
              setDate({
                date_from: a?.from,
                date_until: a?.to,
              });

              if (a?.from && a?.to)
                props?.getReportDashboard({
                  date_from: a?.from,
                  date_until: a?.to,
                  date_numeric: 0,
                });
            }}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
